/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Waiting_ListInputs */

const en_waiting_list = /** @type {(inputs: Waiting_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waiting List`)
};

const de_waiting_list = /** @type {(inputs: Waiting_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warteliste`)
};

/**
* | output |
* | --- |
* | "Waiting List" |
*
* @param {Waiting_ListInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const waiting_list = /** @type {((inputs?: Waiting_ListInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Waiting_ListInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_waiting_list(inputs)
	return en_waiting_list(inputs)
});